import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { BackupLenderTemplate } from '~/backup/lender/domains/page/ui/BackupLenderTemplate';
import { PortfolioView } from '~/backup/lender/views/portfolio/PortfolioView';
import { StratsView } from '~/backup/lender/views/strats/StratsView';
import { AgentView } from '~/backup/shared/views/agent/AgentView';
import { BackupDataPipelineRoutes } from '~/backup/shared/views/data-pipeline/DataPipelineRoutes';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { DefaultErrorRoute } from '~/core/DefaultErrorRoute';

export const BackupLenderRouter = (): React.ReactElement => {
  return (
    <BackupLenderTemplate>
      <Routes>
        <Route
          path="/portfolio"
          element={
            <RouteErrorBoundary
              resetAfterCatch={false}
              fallback={({ message, showErrorToast }) => {
                showErrorToast(message);
                return <DefaultErrorRoute />;
              }}
            >
              <PortfolioView />
            </RouteErrorBoundary>
          }
        />
        <Route
          path="/strats"
          element={
            <RouteErrorBoundary
              resetAfterCatch={false}
              fallback={({ message, showErrorToast }) => {
                showErrorToast(message);
                return <DefaultErrorRoute />;
              }}
            >
              <StratsView />
            </RouteErrorBoundary>
          }
        />
        <Route path="/data-pipeline/*" element={<BackupDataPipelineRoutes />} />
        <Route
          path="/agent"
          element={
            <RouteErrorBoundary
              resetAfterCatch={false}
              fallback={({ message, showErrorToast }) => {
                showErrorToast(message);
                return <DefaultErrorRoute />;
              }}
            >
              <AgentView />
            </RouteErrorBoundary>
          }
        />
        <Route path="/" element={<Navigate to="/portfolio" replace />} />
        <Route path="/*" element={<Navigate to="/portfolio" replace />} />
      </Routes>
    </BackupLenderTemplate>
  );
};
